import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle } from 'lucide-react';
export function ProductSection() {
  const modules = ['Módulo 1: Tu Cuerpo No Es el Problema — La ciencia detrás de la diferencia hormonal', 'Módulo 2: El Mapa de las 4 Estaciones — Guía detallada de cada fase', 'Módulo 3: Nutrición por Fases — Qué comer y cuándo, con alimentos argentinos', 'Módulo 4: Movimiento Inteligente — Entrenamiento sin destruir tus hormonas', 'Módulo 5: Bio-Reparación y Sueño — El protocolo de recuperación hormonal', 'Módulo 6: Plan de Acción de 28 Días — Tu hoja de ruta semana a semana'];
  return <section className="w-full py-10 md:py-16 px-4 bg-gradient-to-b from-[#FDF6F0] to-[#F3E8F0]" data-id="element-99">
      <div className="max-w-6xl mx-auto flex flex-col lg:flex-row items-center gap-6 md:gap-12" data-id="element-100">
        {/* Image Side */}
        <motion.div initial={{
        opacity: 0,
        x: -50
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} className="w-full lg:w-1/2 flex justify-center" data-id="element-101">
          <div className="relative" data-id="element-102">
            <div className="absolute inset-0 bg-brand-purple-light/20 blur-3xl rounded-full" data-id="element-103" />
            <img src="https://cdn.magicpatterns.com/uploads/2rZHzqC9K5dXyqh3uLNAM9/Ebook_Codigo_Hormonal.png" alt="Código Hormonal Ebook Cover" className="relative z-10 w-full max-w-md drop-shadow-xl transform hover:scale-105 transition-transform duration-500" data-id="element-104" />
          </div>
        </motion.div>

        {/* Content Side */}
        <motion.div initial={{
        opacity: 0,
        x: 50
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} className="w-full lg:w-1/2" data-id="element-105">
          <h2 className="text-3xl md:text-5xl font-bold text-brand-text-primary mb-2" data-id="element-106">
            CÓDIGO HORMONAL
          </h2>
          <h3 className="text-xl md:text-2xl text-brand-purple-light mb-5 md:mb-6" data-id="element-107">
            El Protocolo de Biohacking para la Mujer Argentina
          </h3>

          <p className="text-brand-text-body text-lg mb-5 md:mb-8 leading-relaxed" data-id="element-108">
            Una guía completa de 60 páginas con el sistema paso a paso para
            sincronizar tu alimentación, entrenamiento y descanso con tu ciclo
            de 28 días. Adaptado al mercado argentino. Con alimentos reales,
            rutinas posibles y un plan de acción desde el día 1.
          </p>

          <div className="space-y-3 md:space-y-4" data-id="element-109">
            {modules.map((mod, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: 20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="flex items-start gap-3" data-id="element-110">
                <CheckCircle className="w-6 h-6 text-brand-orange flex-shrink-0 mt-1" data-id="element-111" />
                <p className="text-brand-text-body" data-id="element-112">{mod}</p>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}